// 导入组件
import Vue from "vue";
import Router from "vue-router";
// 登录
import login from "@/views/login";
// 首页
import index from "@/views/index";

// 用户管理
import User from "@/views/user/User";
// 管理员管理
import Admin from "@/views/system/Admin";

// 商品管理
import Goods from "@/views/goods/Goods";
// 商品分类
import Classify from "@/views/goods/Classify";
// 交易订单
import Order from "@/views/pay/Order";

// 财务明细
import Finance from "@/views/finance/Finance";
import FinanceStation from "@/views/finance/FinanceStation";
import taskPlatformTask from "@/views/task/platformTask";
import home from "@/views/home/home";

// 分类管理
// 发布分类列表
import Classification from "@/views/classification/Classification";

// 附近商家分类 
import nearbyMerchants from "@/views/classification/merchant_type"

// 字典列表配置
import dictConfigure from "@/views/dict_configure/dict"

// 作品管理
// 作品列表
import Works from "@/views/works/Works";

// 活动管理
// 活动列表
import Activity from "@/views/activity/Activity";

// 报名记录 
import tutorRecordList from "@/views/registration_admin/tutor_record_list.vue"
import parentRecordList from "@/views/registration_admin/parent_record_list.vue"
import rechargeRecord from "@/views/registration_admin/recharge_record.vue"

// 放映厅管理
// 放映厅列表
import ScreenRoom from "@/views/show/ScreenRoom";
// 放映厅视频列表
import Video from "@/views/Video";
// 放映厅购买列表
import RoomBuy from "@/views/show/RoomBuy";

// 金字塔管理
// 金字塔列表
import Pyram from "@/views/pyram/Pyram";

// 圈层管理
// 圈层列表
import Circles from "@/views/circles/Circles";
// 圈层申请列表
import Examine from "@/views/circles/Examine";

// 课程管理

// 课程列表
import Task from "@/views/task/Task";
// 课程视频列表
import TaskToVideo from "@/views/task/TaskToVideo";
// 课程标签列表
import TaskTag from "@/views/task/TaskTag";

// 拉新配置管理
import Laxin from '@/views/laxin/Laxin'

// 卡密管理
// 卡密列表
import Cami from '@/views/Cami/Cami'
// 卡密批次列表
import CamiBatch from '@/views/Cami/CamiBatch'

// 提现管理
import Withdraw from "@/views/terrace/Withdraw";
// 押金管理
import Deposit from "@/views/finance/Deposit";

// 轮播图管理
import Carousel from "@/views/terrace/Carousel";

// 协议管理
import Agreement from "@/views/terrace/Agreement";

// 资讯分类管理
import NewsClassify from "@/views/terrace/NewsClassify";

// 评论管理
import Review from "@/views/terrace/Review";

// 站点管理
import Valuation from "@/views/terrace/Valuation";
import toExamine from "@/views/terrace/toExamine";

// 资讯分类管理
import Ledger from "@/views/ledger/Ledger";
import Feedback from "../views/terrace/Feedback.vue";
import payBalance from "../views/pay/balance.vue";
import walletBalanceDetails from "../views/pay/walletBalanceDetails.vue";
//实名认证
import realName from "../views/terrace/realName.vue";
import Permission from "../views/terrace/Permission.vue";
import Role from "../views/terrace/Role.vue";
import sysUser from "../views/terrace/user.vue";

// 开屏广告
import advertisement from "@/views/banner_admin/banner_list"

// 教培机构
import institution from "@/views/institution_admin/institution_list"

// 商家服务 
import merchant from "@/views/merchant/merchant_list"
// 自习室管理
import room_admin from "@/views/room_admin/room_list"

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [
    {
      path: "/",
      name: "",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/login",
      name: "登录",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },

    {
      path: "/index",
      name: "首页",
      component: index,
      iconCls: "el-icon-tickets",
      children: [
        {
          path: "/User/User",
          name: "用户管理",
          component: User,
          meta: {
            requireAuth: true
          }
        }, {
          path: "/advertisement/advertisement",
          name: "广告管理",
          component: advertisement,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/home/home",
          name: "数据统计",
          component: home,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/realName",
          name: "实名认证",
          component: realName,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/role",
          name: "角色管理",
          component: Role,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/user",
          name: "系统用户",
          component: sysUser,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/permission",
          name: "权限管理",
          component: Permission,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/task/taskPlatformTask",
          name: "平台发布课程",
          component: taskPlatformTask,
          hidden: true,
          meta: {
            requireAuth: false
          }
        },
        {
          path: "/goods/Goods",
          name: "商品管理",
          component: Goods,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/pay/payBalance",
          name: "充值记录",
          component: payBalance,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/pay/walletBalanceDetails",
          name: "充值记录",
          component: walletBalanceDetails,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/goods/Classify",
          name: "商品分类",
          component: Classify,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/pay/Order",
          name: "交易订单",
          component: Order,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finance/Finance",
          name: "财务明细",
          component: Finance,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finance/FinanceStation",
          name: "站点财务明细",
          component: FinanceStation,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/Withdraw",
          name: "提现管理",
          component: Withdraw,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/finance/Deposit",
          name: "押金管理",
          component: Deposit,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/Carousel",
          name: "轮播图管理",
          component: Carousel,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/Agreement",
          name: "协议管理",
          component: Agreement,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/NewsClassify",
          name: "分类管理",
          component: NewsClassify,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/Valuation",
          name: "基础设置",
          component: Valuation,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/toExamine",
          name: "审核管理",
          component: toExamine,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/Review",
          name: "评价管理",
          component: Review,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/terrace/Feedback",
          name: "用户反馈",
          component: Feedback,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/system/Admin",
          name: "管理员管理",
          component: Admin,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/ledger/Ledger",
          name: "台账管理",
          component: Ledger,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/classification/Classification",
          name: "分类列表",
          component: Classification,
          meta: {
            requireAuth: true
          }
        },{
          path: "/nearbyMerchants/nearbyMerchants",
          name: "分类列表",
          component: nearbyMerchants,
          meta: {
            requireAuth: true
          }
        },{
          path: "/dictConfigure/dictConfigure",
          name: "字典配置",
          component: dictConfigure,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/works/Works",
          name: "作品列表",
          component: Works,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/activity/Activity",
          name: "活动列表",
          component: Activity,
          meta: {
            requireAuth: true
          }
        },{
          path: "/registration_admin/tutorRecordList",
          name: "家教报名",
          component: tutorRecordList,
          meta: {
            requireAuth: true
          }
        },{
          path: "/registration_admin/parentRecordList",
          name: "家长报名",
          component: parentRecordList,
          meta: {
            requireAuth: true
          }
        },{
          path: "/registration_admin/rechargeRecord",
          name: "为学学院充值记录",
          component: rechargeRecord,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/show/ScreenRoom",
          name: "放映厅列表",
          component: ScreenRoom,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/Video",
          name: "视频列表",
          component: Video,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/show/RoomBuy",
          name: "放映厅购买列表",
          component: RoomBuy,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/institution/institution",
          name: "教培结构列表",
          component: institution,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/merchant/merchant",
          name: "商家服务",
          component: merchant,
          meta: {
            requireAuth: true
          }
        },{
          path: "/room_admin/room_list",
          name: "自习室管理",
          component: room_admin,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/pyram/Pyram",
          name: "金字塔列表",
          component: Pyram,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/circles/Circles",
          name: "圈层列表",
          component: Circles,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/circles/Examine",
          name: "圈层申请列表",
          component: Examine,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/task/Task",
          name: "课程列表",
          component: Task,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/task/TaskToVideo",
          name: "课程视频列表",
          component: TaskToVideo,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/task/TaskTag",
          name: "课程标签列表",
          component: TaskTag,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/laxin/Laxin',
          name: '拉新配置列表',
          component: Laxin,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/cami/Cami',
          name: '卡密列表',
          component: Cami,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/cami/CamiBatch',
          name: '卡密批次列表',
          component: CamiBatch,
          meta: {
            requireAuth: true
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js